import type { ReasonDistribution } from '@/types/newsletter'

interface AudienceUnsubReasonsProps {
  distribution: ReasonDistribution[]
}

export function AudienceUnsubReasons({
  distribution,
}: AudienceUnsubReasonsProps): React.JSX.Element | null {
  if (distribution.length === 0) {
    return null
  }

  const total = distribution.reduce((sum, r) => sum + r.count, 0)

  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-5">
      <h3 className="mb-4 text-sm font-medium text-text-primary">Reason Distribution</h3>
      <div className="space-y-3">
        {distribution.map((item) => {
          const pct = total > 0 ? Math.round((item.count / total) * 100) : 0
          return (
            <div key={item.reason}>
              <div className="mb-1 flex items-center justify-between text-sm">
                <span className="text-text-secondary">{item.reason}</span>
                <span className="font-medium text-text-primary">
                  {item.count} ({pct}%)
                </span>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-surface-2">
                <div
                  className="h-full rounded-full bg-brand-500 transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
